(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-with-readmore"] && !window.DesignMode) return;
  try {
    

jQuery(document).ready(function($) {
  $('.readmore-text').hide();
  $('.readmore-text').after('<a class="readMore" style="cursor:pointer;margin-bottom:12px;display:inline-block;">Read More</a>');
  $('.readMore').click(function(){
  $(this).prev().slideToggle(200,function() {
    $(this).next('.readMore').text(function (index, text) {
      return (text == 'Read More' ? 'Close' : 'Read More');
    });
    });
  	return false;
  });
});

  } catch(e) { console.error(e); }
})();
})();
